import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import useQuery from '../../utils/hook/useQuery';
import List from './listHelpical';
import { useParams } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { closeTicketAction, getTicketAction, getTicketsCountAction, } from '../orders/actions';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectTicketList,
} from '../orders/selectors';
import {
  Props,
  SelectorProps,
  Payload,

} from '../orders/interfaces';
import { Store } from '../../redux/reducers';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import TicketCards from '../../components/Cards/ticketCards';





const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      justifyContent: 'space-between'
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },

  })
);

const HelpicalDetails = props => {
  const params = useParams();

  const classes = useStyles();
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'parentId.specified': false,
    'parcelId.equals': params?.id,
  });




  useEffect(() => {
    getTicket();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getTicket = () => {
    props.ticketDispatch({
      id: params.id
    })
  }

  const handleClose = () => {
    props.closeTicketDispatch({
      payload: {
        id: params.id,
      }, callback: () => {
        getTicket();
      },
    })

  }

  return (
    <React.Fragment>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              پیام‌های {params.id}
            </Typography>
            <Button size='medium' variant='outlined' color='primary' onClick={handleClose} style={{ marginLeft: '150px' }}>
              بستن پیام
            </Button>
          </div>
        </Paper>
      </Grid>
      <Grid container md={12} spacing={2} >
        {
          props.msgList.map(el => {
            return (

              <TicketCards data={el} />
            )

          })
        }
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  msgList: makeSelectTicketList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ticketDispatch: (payload: Payload) => dispatch(getTicketAction(payload)),
    closeTicketDispatch: (payload: Payload) => dispatch(closeTicketAction(payload)),

  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(HelpicalDetails);
